import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { QboCustomerLinker } from "@/components/QboCustomerLinker";
import { api } from "@/lib/api";

// Account page card: is this customer in QuickBooks yet? Sync / match / link from here.
export const QboCustomerCard = ({ customerId }) => {
  const [status, setStatus] = useState(null);

  useEffect(() => {
    api
      .get("/qbo/status")
      .then(({ data }) => setStatus(data))
      .catch(() => setStatus(null));
  }, []);

  if (!status?.configured) return null;

  return (
    <div
      className="rounded-lg border border-zinc-800 bg-zinc-900 p-4"
      data-testid="customer-qbo-card"
    >
      <div className="flex items-center justify-between gap-2">
        <div className="text-xs font-bold uppercase tracking-widest text-zinc-300">
          QuickBooks
        </div>
        {status.connected ? (
          <span className="text-[10px] uppercase tracking-widest text-emerald-400">
            {status.company_name || "Connected"}
          </span>
        ) : (
          <Link
            to="/settings/integrations"
            data-testid="customer-qbo-connect-link"
            className="text-[10px] uppercase tracking-widest text-amber-300 hover:underline"
          >
            Not connected
          </Link>
        )}
      </div>
      <div className="mt-3">
        <QboCustomerLinker customerId={customerId} connected={status.connected} />
      </div>
    </div>
  );
};
